import angular from "angular";
import organizationControlComponent from "./organizations-control.component";

angular.module('organizationsControl', [
    organizationControlComponent
]);


export default 'organizationsControl';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/organizations-control.module.js